import { CloseOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { Modal, Input, Button, Select } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { OFIS_CASH_USD,OFIS_CASH_UZS } from '@/constants/index.js'
import ErrorModal from '@components/Modal/ErrorModal'
import SuccessModal from '@components/Modal/SuccessModal'
import { http } from '@services/http'
import {
	fetchDdsArticle,
	fetchCashAccounts,
	fetchDocRate,
} from '@utils/fetchData'
import { formatInputNumber, removeSpaces } from '@utils/numberWithSpaces'



const SendMoneyToOffice = ({ visible, onClose, onSuccess }) => {
	const { t } = useTranslation()
	const successRef = useRef()
	const errorRef = useRef()

	const {getMe} = useSelector((state) => state.main)
	const uzsCash = useSelector((state) => state.main.uzsCash)
	const usdCash = useSelector((state) => state.main.usdCash)
	const roleNames = useSelector((state) => state.main.roleNames)

	const [loading, setLoading] = useState(false)
	const [currency, setCurrency] = useState('')
	const [comment, setComment] = useState('')
	const [amount, setAmount] = useState('')
	const [docRate, setDocRate] = useState('')
	const [fromCash, setFromCash] = useState('')
	const [toCash, setToCash] = useState('')


	const postData = async () => {
		setLoading(true)
		try {
			const paymentAccounts = [
				{
					accountCode: toCash,
					sumPaid: Number(removeSpaces(amount)),
				},
			]
			await http.post('api/vendorpayments', {
				cardCode: toCash,
				cashAccount:fromCash,
				docCurrency: currency,
				cashSum: Number(removeSpaces(amount)),
				remarks: comment,
				paymentAccounts,
					u_DdsArticle: "Сдача средств в сейф",
				docRate: +removeSpaces(docRate),
			})
			resetForm()
			onClose()
			onSuccess?.()

			successRef.current.open(t('sucCreated'))
		} catch (error) {
			errorRef.current.open(error?.response?.data?.message)
		} finally {
			setLoading(false)
		}
	}

	const resetForm = () => {
		setLoading(false)
		setCurrency('')
		setComment('')
		setToCash('')
		setFromCash('')
		setAmount('')
		setDocRate('')
	}

	const { data: todayDocRate, } = useQuery({
		queryKey: ['docRate'],
		queryFn: fetchDocRate,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
	})

	useEffect(() => {
		if (todayDocRate) {
			setDocRate(todayDocRate)
		}
	}, [todayDocRate, visible])



	const { data: cashAccountsData = [], isLoading: cashLoading } = useQuery({
		queryKey: ['cash-accounts'],
		queryFn: fetchCashAccounts,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	return (
		<Modal
			open={visible}
			onCancel={onClose}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="65%"
			style={{ height: '70%' }}
		>
			<div className="w-full px-2 sm:px-5 overflow-y-auto">

			<div className="flex items-center  gap-10 mt-5">

				<div className="flex flex-col gap-3 ">
						<p className="font-bold">{t('currency')}</p>
						<Select
							type="text"
							onChange={(val) => {
								setCurrency(val)
								if(val === 'USD') {
									setFromCash(usdCash)
									setToCash(OFIS_CASH_USD)
								} else if(val === 'UZS') {
									setFromCash(uzsCash)
									setToCash(OFIS_CASH_UZS)
								}
							}}
							value={currency}
							className="flex h-8 w-[150px] items-center justify-center "
						>
							<Select.Option value={'USD'}>USD</Select.Option>
							<Select.Option value={'UZS'}>UZS</Select.Option>
						</Select>
					</div>

					<div className="flex flex-col items-start gap-3 ">
						<p className="font-bold">{t('docRate')}</p>
						<Input
							type="text"
							value={formatInputNumber(docRate, 2)}
							className=" h-8 w-auto "
							onChange={(e) => {
								setDocRate(e.target.value)
							}}
							disabled={!roleNames.includes('admin')}
						/>
					</div>

						<div className="flex flex-col items-start gap-3 ">
											<p className="font-bold">{t('payingAmount')}</p>
											<Input
												type="text"
												onChange={(e) => {
													setAmount(e.target.value)
												}}
												value={formatInputNumber(amount, 2)}
												className="flex h-8 w-[250px] items-center justify-center border-[1px] border-[#D0D0D0]"
											/>
										</div>
			</div>

				<div className="flex items-center justify-between mt-5">
					<div className=" flex flex-col items-start gap-3  ">
						<p className="font-bold">{t('fromCashAcc')}</p>
						<Select
							type="text"

							value={fromCash}
							disabled
							loading={cashLoading}
							className="flex h-8 w-[350px] items-center justify-center"
						>
							{cashAccountsData
								.map((cash, idx) => (
									<Select.Option
										key={idx}
										value={cash.acctCode}
									>
										{`${cash.acctCode} - ${cash.acctName}`}
									</Select.Option>
								))}
						</Select>
					</div>
					<div className=" flex flex-col items-start gap-3  ">
						<p className="font-bold">{t('toCashAcc')}</p>
						<Select
							type="text"
							value={toCash}
							disabled
							loading={cashLoading}
							className="flex h-8 w-[350px] items-center justify-center"
						>
							{cashAccountsData
								.map((cash, idx) => (
									<Select.Option
										key={idx}
										value={cash.acctCode}
									>
										{`${cash.acctCode} - ${cash.acctName}`}
									</Select.Option>
								))}
						</Select>
					</div>

				</div>





				<div className="flex flex-col items-start gap-3 w-full mt-5">
					<p className="font-bold">{t('comments')}</p>
					<TextArea
						onChange={(e) => {
							setComment(e.target.value)
						}}
						value={comment}
						className="w-full"
						rows={4}
					/>
				</div>

				<div className="flex items-center gap-10 mt-14 justify-between">
					<Button
						onClick={() => {
							onClose()
						}}
						className="w-full bg-red-600 h-[35px] rounded-lg text-white"
					>
						{t('back')}
					</Button>
					<Button
						onClick={postData}
						loading={loading}
						disabled={loading}
						className="w-full bg-[#0A4D68] h-[35px] rounded-lg text-white"
					>
						{t('add')}
					</Button>
				</div>
			</div>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</Modal>
	)
}

export default SendMoneyToOffice
